import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import { Link } from 'react-router-dom';
import {
  fetchTest,
  updateTest,
  deleteTest,
  getDeviceTypes,
  getQCDeviceTypes,
  updatePhoto,
  deletePhoto,
  syncWithIsn
} from '../../actions/tests/apiRequests';
import { postReport } from '../../actions/isn/apiRequests';
import { fetchReportOptionsFromTest } from '../../actions/companies/apiRequests';
import {
  notifyInfo,
  notifyError
} from '../../utils/notifier';
import {
  Pressure,
  Radon,
  Temperature,
  getMDCAverageRadonValue
} from '../../utils/uom';
import {
  IMPERIAL,
  METRIC,
  DEFAULT_UOM,
  SYSTEMS_OF_MEASURE
} from '../../constants/uom';
import { TEST_TYPES } from '../../constants/test';
import Page from '../shared/Page';
import Loader from '../shared/Loader';
import Button from '../shared/Button';
import SaveButton from  '../shared/SaveButton';
import ActionModal from '../shared/ActivationModal';
import withRoleRestrictions from '../shared/withRoleRestrictions';
import ExportTestCard from './ExportTestCard';
import NotesCard from './NotesCard';
import TestInfo from './TestInfo';
import QCTestInfo from './QCTestInfo';
import TestResultsTable from './TestResultsTable';
import QCToggle from './QCToggle';
import { getBreadCrumbs } from '../../utils/breadCrumbs';
import * as ReportLayoutDropdown from '../../utils/reportLayoutDropdown';
import {
  MANAGE_TESTS,
  PAGE_PATHS
} from '../../constants/pathsRoots';
import TestImages from './TestImages';
import IsnIntegration from './IsnIntegration';
import IsnPostReport from './IsnPostReport';
import Modal from '../shared/Modal';
import withEulaRestrictions from '../license/withEulaRestrictions';
import RequiredAsterisk from '../shared/RequiredAsterisk';
import styles from './styles.scss';

const propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
  history: PropTypes.object,
  user: PropTypes.object
};

class TestsDetailsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      testId: props.match.params.id,
      test: null,
      errors: {},
      qcErrors: {},
      loading: true,
      saving: false,
      showValidationErrors: false,
      deleted: false,
      showActionModal: false,
      deviceTypes: {},
      images: [null, null],
      deleteImages: [false, false],
      testImagesBase64: [],
      fileUploadError: false,
      filesMaxIsReachedError: false,
      isDataCollecting: false,
      isnDataPosting: false,
      isnDataPostedResult: null,
      layout: null,
      layoutOptions: [],
    };

    this.onFieldChange = this.onFieldChange.bind(this);
    this.onFieldValidate = this.onFieldValidate.bind(this);
    this.onQcFieldChange = this.onQcFieldChange.bind(this);
    this.onQcFieldValidate = this.onQcFieldValidate.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onSwitchUom = this.onSwitchUom.bind(this);
    this.toggleActionModal = this.toggleActionModal.bind(this);
    this.onDeleteTestSuccess = this.onDeleteTestSuccess.bind(this);
    this.onLoadImage = this.onLoadImage.bind(this);
    this.onClearImage = this.onClearImage.bind(this);
    this.updateTest = this.updateTest.bind(this);
    this.showErrorWindow = this.showErrorWindow.bind(this);
    this.hideErrorWindow = this.hideErrorWindow.bind(this);
    this.onIsnGetData = this.onIsnGetData.bind(this);
    this.onIsnPostData = this.onIsnPostData.bind(this);
    this.changeLayout = this.changeLayout.bind(this);

    this.maxImages = 2;
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    Promise.all([this.fetchDefaultReportLayout(), fetchTest(this.state.testId)])
      .then(([defaultLayout, test]) => {
        const layoutOptions = ReportLayoutDropdown.getBasicTestOptions({
          isQcTest: test.isQcTest,
        });

        this.setState({
          layoutOptions,
          layout: defaultLayout,
          test,
          testImagesBase64: [test.photo1Base64, test.photo2Base64],
          loading: false
        });
      })
      .catch(() => this.setState({
        loading: false
      }));

    getDeviceTypes()
      .then((deviceTypes) => {
        this.setState({
          deviceTypes
        })
      });

    getQCDeviceTypes()
      .then((qcDeviceTypes) => {
        this.setState({
          qcDeviceTypes
        })
      });
  }

  onLoadImage(files) {
    const { images, testImagesBase64 } = this.state;
    const filesMaxIsReachedError = images.filter(Boolean).length === this.maxImages
      || testImagesBase64.filter(Boolean).length === this.maxImages;

      this.setState({
        filesMaxIsReachedError,
        images: images.map((image, index) => ((!testImagesBase64[index] && !image) ? files.shift() : image))
      });
  }

  onIsnGetData() {
    const { test } = this.state;
    this.setState((prevState)=>({isDataCollecting: !prevState.isDataCollecting}));

    syncWithIsn(test.id).then((data) => {
      this.setState((prevState)=>({
        isDataCollecting: !prevState.isDataCollecting,
        test: data
      }));
      notifyInfo();
    })
    .catch((error) => {
      this.setState((prevState)=>({
        isDataCollecting: !prevState.isDataCollecting
      }));

      if (error.message) {
        notifyError(error.message);
      }
      else {
        notifyError("There was an error retrieving your test data from your ISN account. Please retry later or contact your system administrator for assistance.");
      }
    });
  }

  onIsnPostData() {
    const { test, layout, isnDataPosting } = this.state;

    this.setState((prevState)=>({
      isnDataPostedResult: {},
      isnDataPosting: !prevState.isnDataPosting
    }));

    postReport(test.id, layout).then((result) => {
        this.setState((prevState)=>({
          isnDataPostedResult: result,
          isnDataPosting: !prevState.isnDataPosting,
        }));
      })
      .catch((error) => {
        this.setState((prevState)=>({
          isnDataPostedResult: {
            message: error.message
          },
          isnDataPosting: !prevState.isnDataPosting
        }));

        if (error.message) {
          notifyError(error.message);
        }
        else {
          notifyError("There was an error retrieving your test data from your ISN account. Please retry later or contact your system administrator for assistance.");
        }
      });
  }

  onClearImage(getIndex) {
    const {
      images,
      deleteImages,
      testImagesBase64
    } = this.state;


    this.setState({
      images: images.map((image, index) => ((index === getIndex) ? null : image)),
      testImagesBase64: testImagesBase64.map((image, index) => ((index === getIndex) ? null : image)),
      deleteImages: deleteImages.map((item, index) => ((index === getIndex) ? true : item)),
    });
  }

  uploadPhoto({ id }, files = null) {
    const { deleteImages } = this.state;

    if (deleteImages[0] || deleteImages[1]) {
      deleteImages.forEach((item, index) => item && deletePhoto(id, index + 1)
        .then(() => this.setState({ deleteImages: [false, false] })));
    }

    if (files[0] || files[1]) {
      files.forEach((file, index) => file && updatePhoto(id, index + 1, file))
    }

    return Promise.resolve();
  }

  updateTest() {
    fetchTest(this.state.testId)
      .then((test) =>
        this.setState({
          test,
          testImagesBase64: [test.photo1Base64, test.photo2Base64],
          deleteImages: [false, false],
          images: [null, null]
        }));
  }

  hideErrorWindow() {
    this.setState({
      fileUploadError: false,
      filesMaxIsReachedError: false
    });
  }

  showErrorWindow() {
    this.setState({
      fileUploadError: true
    });
  }

  parseSeparatedEmails(emails) {
    if (!emails) return [];

    const emailArray = [];
    const contactEmail = emails.split(',');
    contactEmail.map(email => {
      email = email.trim();
      emailArray.push({
        value: email,
        label: email,
        className: "Select-create-option-placeholder"
      });
    });
    return emailArray;
  }

  render() {
    const {
      test,
      loading,
      deleted,
      images,
      testImagesBase64,
      fileUploadError,
      filesMaxIsReachedError,
      isDataCollecting,
      isnDataPosting,
      isnDataPostedResult,
      layout,
      qcTest
    } = this.state;
    const { user } = this.props;
    const header = this.editMode ? 'Edit Test' : 'View Test';
    const actions = this.editMode ? this.editButtons : this.viewButtons;
    const { pathname } = this.props.location;

    const showIsnBox = test && (test.isIsn || (test.company && test.company.isIsn));

    return (
      <Choose>
        <When condition={loading}>
          <Page header={header}>
            <Loader />
          </Page>
        </When>
        <When condition={deleted}>
          <Redirect to='/tests' />
        </When>
        <When condition={test}>
          <Page
            header={header}
            actions={actions}
            breadCrumbs={getBreadCrumbs(header, pathname, [PAGE_PATHS[MANAGE_TESTS]])}
          >
            <p className={styles.requiredNote}>
              <RequiredAsterisk /> - Field must be completed to generate Official Report
            </p>
            <Container fluid className='px-0 mx-0'>
              <Row>
                <Col lg={6}>
                  {this.renderTestInfo()}
                </Col>
                <Col lg={6}>
                  <If condition={this.editMode}>
                    <QCToggle
                      onChange={(value) => this.onFieldChange('testType', value)}
                      testType={test.testType}
                    />
                  </If>
                  <If condition={this.qcTest}>
                    {this.renderQcTestInfo()}
                  </If>
                  {this.renderNotes()}
                  <If condition={!this.editMode}>
                    {this.renderExports()}
                  </If>
                  <TestImages
                    edit={this.editMode}
                    imageDeleted={true}
                    imageBase64={testImagesBase64}
                    images={images}
                    onLoad={this.onLoadImage}
                    onClear={this.onClearImage}
                    showErrorWindow={this.showErrorWindow}
                    maxImages={this.maxImages}
                  >
                  </TestImages>
                  <Choose>
                    <When condition={this.editMode}>
                      <If condition={showIsnBox}>
                        <IsnIntegration
                          canEdit={false}
                          test={test}
                          onIsnGetData={this.onIsnGetData}
                          isDataCollecting={isDataCollecting}
                        />
                      </If>
                    </When>
                    <Otherwise>
                      <If condition={showIsnBox}>
                        <IsnPostReport
                          canEdit={false}
                          test={test}
                          onIsnPostData={this.onIsnPostData}
                          isDataCollecting={isDataCollecting}
                          isnDataPosting={isnDataPosting}
                          isnDataPostedResult={isnDataPostedResult}
                          tzAbbr={user.tzAbbr}
                          qcTest={test.qcTest}
                          hasData={test.hasData}
                          isTestCompleted={test.isCompleted}
                          layout={layout}
                        />
                        </If>
                    </Otherwise>
                  </Choose>
                </Col>
              </Row>
              {this.renderIntervalReport()}
            </Container>
            {this.renderActionModal()}
          </Page>

          <Modal
            isOpen={fileUploadError}
            showCancelButton={false}
            onConfirm={this.hideErrorWindow}
            header='Files upload error'
          >
            Files could not be uploaded. Make sure the each file has an image extension and its size less than 1Mb
        </Modal>
        <Modal
          isOpen={filesMaxIsReachedError}
          showCancelButton={false}
          onConfirm={this.hideErrorWindow}
          header='Maximum files are reached'
        >
          You can only upload a maximum of {this.maxImages} images per test.
        </Modal>
        </When>
        <Otherwise>
          <Page header={header}>
            <div className='text-center'>
              <p className='m-5'>Test was not found or access denied</p>
            </div>
          </Page>
        </Otherwise>
      </Choose>
    );
  }

  renderIntervalReport() {
    const {
      intervalReport,
      serialNumber
    } = this.state.test || {};
    const {
      test,
      deviceTypes
    } = this.state;
    const { uom } = this.props.user;
    return (
      <Choose>
        <When condition={intervalReport}>
          <Row>
            <div className='mb-1 col-md-6'>
              <h3>Test data</h3>
            </div>
            <div className='mb-1 col-md-6'>
              <div className='p-2 offset-md-5 col-md-7 border text-center'>
                <h3 className='mr-2'>{`Average Radon ${getMDCAverageRadonValue(test, uom, deviceTypes)} ${SYSTEMS_OF_MEASURE[uom].radon}`}</h3>
              </div>
            </div>
          </Row>
          <Row>
            <div className='ml-3 col-md-3'>
              <h5>{serialNumber}</h5>
            </div>
          </Row>
          <Row className='mt-3'>
            <TestResultsTable
              results={intervalReport.data}
              showRadon={intervalReport.allowToShowRadon}
              showAlpha={intervalReport.allowToShowAlpha}
              showTemperature={intervalReport.allowToShowTemperature}
              showHumidity={intervalReport.allowToShowHumidity}
              showPressure={intervalReport.allowToShowPressure}
            />
          </Row>
        </When>
      </Choose>
    );
  }

  renderActionModal() {
    const {
      testId,
      showActionModal
    } = this.state;
    return (
      <ActionModal
        message={`Are you sure you want to delete test?`}
        isOpen={showActionModal}
        action={() => deleteTest(testId)}
        onCancel={this.toggleActionModal}
        onSuccess={this.onDeleteTestSuccess}
        onError={() => notifyError()}
      />
    );
  }

  renderTestInfo() {
    const {
      test,
      errors,
      showValidationErrors,
    } = this.state;
    const { user } = this.props;

    return (
      <TestInfo
        test={test}
        tzAbbr={user.tzAbbr}
        errors={errors}
        editMode={this.editMode}
        editTester={user.isCompanyUser}
        onFieldChange={this.onFieldChange}
        onFieldValidate={this.onFieldValidate}
        showErrors={showValidationErrors}
      />
    );
  }

  renderQcTestInfo() {
    const {
      test,
      qcErrors,
      showValidationErrors,
      qcDeviceTypes
    } = this.state;
    const { user } = this.props;

    return (
      <QCTestInfo
        qc={test.qc}
        defaultUom={user.uom}
        onSwitchUom={this.onSwitchUom}
        editMode={this.editMode}
        onFieldChange={this.onQcFieldChange}
        onFieldValidate={this.onQcFieldValidate}
        errors={qcErrors}
        showErrors={showValidationErrors}
        qcDeviceTypes={Object.keys(qcDeviceTypes)}
      />
    );
  }

  renderNotes() {
    const { test } = this.state;

    return(
      <NotesCard
        notes={test.notes}
        editMode={this.editMode}
        onFieldChange={this.onFieldChange}
      />
    );
  }

  changeLayout(layout) {
    this.setState({ layout });
  }

  renderExports() {
    const {
      testId,
      test,
      layout,
      layoutOptions,
    } = this.state;

    let defaultEmailCc = [];
    if (test) {
      defaultEmailCc = this.parseSeparatedEmails(test.buyerEmail);
      defaultEmailCc = defaultEmailCc.concat(this.parseSeparatedEmails(test.inspectorEmail));
    }

    return (
      <ExportTestCard
        testId={testId}
        defaultEmailTo={test ? this.parseSeparatedEmails(test.contactEmail) : []}
        defaultEmailCc={defaultEmailCc}
        hasData={test.hasData}
        isTestCompleted={test.isCompleted}
        reportLayout={layout}
        reportLayoutOptions={layoutOptions}
        onChangeReportLayout={this.changeLayout}
      />
    );
  }

  get editMode() {
    const { location={} } = this.props;
    return location.state && location.state.editMode;
  }

  get editButtons() {
    const { isSpruceAdmin } = this.props.user;
    return [
      <If condition={isSpruceAdmin} key='delete'>
        {this.deleteButton}
      </If>,
      this.cancelButton,
      this.saveButton,
      this.viewButton
    ];
  }

  get viewButtons() {
    return [
      this.cancelButton,
      this.editButton
    ];
  }

  get cancelButton() {
    return (
      <Link
        to={{
          pathname: `/tests/`,
        }}
        key='cancel'
      >
        <Button kind='primary' className='mr-3'>Cancel</Button>
      </Link>
    );
  }

  get saveButton() {
    const { saving } = this.state;
    return (
      <SaveButton
        key='save'
        onClick={this.onSave}
        loading={saving}
        disabled={saving}
      />
    );
  }

  get viewButton() {
    return (
      <Link to={{
        pathname:`/tests/${this.state.testId}`,
        state: { editMode: false }
      }}
            key='view'
      >
        <Button
          onClick={this.updateTest}
          kind='primary' className='ml-3 mr-3'>
          View Test
        </Button>
      </Link>
    );
  }

  get editButton() {
    return (
      <Link to={{
          pathname:`/tests/${this.state.testId}`,
          state: { editMode: true }
        }}
        key='edit'
      >
        <Button kind='primary' className='mr-2'>
          Edit Test
        </Button>
      </Link>
    );
  }

  get deleteButton() {
    return(
      <Button
        kind='danger'
        className='mr-5'
        onClick={this.toggleActionModal}
      >
        Delete
      </Button>
    );
  }

  get isValid() {
    const {
      errors,
      qcErrors
    } = this.state;
    const hasErrors = Object.values(errors)
      .filter(value => value)
      .length;
    const hasQcErrors = Object.values(qcErrors)
      .filter(value => value)
      .length;

    if (this.qcTest) {
      return !hasErrors && !hasQcErrors;
    }

    return !hasErrors;
  }

  get qcTest() {
    const { test={} } = this.state;
    return test.testType === TEST_TYPES.qc;
  }

  onFieldChange(name, value) {
    this.setState((prevState) => ({
      test: {
        ...prevState.test,
        [name]: value
      }
    }));
  }

  onFieldValidate(name, error) {
    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        [name]: error
      }
    }));
  }

  onQcFieldChange(name, value) {
    this.setState((prevState) => ({
      test: {
        ...prevState.test,
        qc: {
          ...prevState.test.qc,
          [name]: value
        }
      }
    }));
  }

  onQcFieldValidate(name, error) {
    this.setState((prevState) => ({
      qcErrors: {
        ...prevState.qcErrors,
        [name]: error
      }
    }));
  }

  onSwitchUom(toUom) {
    const {
      unitOfMeasure,
      averagePressure,
      averageRadon,
      averageTemperature
    } = this.state.test.qc || {};

    const fromUom = SYSTEMS_OF_MEASURE[unitOfMeasure || DEFAULT_UOM];
    const pressure = new Pressure(Number(averagePressure || 0), fromUom.pressure);
    const radon = new Radon(Number(averageRadon || 0), fromUom.radon);
    const temperature = new Temperature(Number(averageTemperature || 0), fromUom.temperature);

    if (toUom === IMPERIAL) {
      this.onQcFieldChange(
        'averagePressure',
        averagePressure && pressure.toImperial().toFixed(2)
      );
      this.onQcFieldChange(
        'averageRadon',
        averageRadon && radon.toImperial().toFixed(1)
      );
      this.onQcFieldChange(
        'averageTemperature',
        averageTemperature && temperature.toImperial().toFixed(2)
      );
    }

    if (toUom === METRIC) {
      this.onQcFieldChange(
        'averagePressure',
        averagePressure && pressure.toMetric().toFixed(2)
      );
      this.onQcFieldChange(
        'averageRadon',
        averageRadon && radon.toMetric().toFixed()
      );
      this.onQcFieldChange(
        'averageTemperature',
        averageTemperature && temperature.toMetric().toFixed(2)
      );
    }

    this.onQcFieldChange('unitOfMeasure', toUom);

  }

  onSave() {
    const {
      test,
      images
    } = this.state;
    this.setState({ showValidationErrors: true });

    if (!this.isValid) {
      return;
    }

    this.setState({ saving: true });
    return updateTest(test.id, test)
      .then(() => notifyInfo())
      .catch(() => notifyError())
      .then(() => this.uploadPhoto(test, images))
      .then(() => this.setState({ saving: false }));
  }

  fetchDefaultReportLayout() {
    const { testId } = this.state;

    return fetchReportOptionsFromTest(testId).then(({ defaultLayout }) => defaultLayout)
  }

  toggleActionModal() {
    this.setState((prevState) => ({
      showActionModal: !prevState.showActionModal
    }));
  }

  onDeleteTestSuccess() {
    this.setState({
      deleted: true
    });
  }
}

TestsDetailsPage.propTypes = propTypes;

const mapStateToProps = ({ profile }) => ({
  user: profile
});

export default connect(mapStateToProps)(
  withEulaRestrictions(withRoleRestrictions(TestsDetailsPage))
);



// WEBPACK FOOTER //
// src/components/testDetails/TestDetailsPage.jsx